import React from "react";
import PropTypes from "prop-types";
import WarningYellowOutline from "@druva-apps/orion-icons/lib/WarningYellowOutline";

import Spinner from "../../spinner";
import { isString } from "../utils";
import Tooltip from "../../tooltip/tooltip";

const TableHeaderCell = ({ className, column }) => {
  const { isLoading, isError } = column;

  return (
    <Tooltip
      overflowOnly
      text={isString(column.title) ? column.title : () => column.title}
    >
      <div className={className}>{column.title}</div>
      {isLoading && <Spinner size="sm" className="oui-ml-1 oui-mr-1" />}
      {isError && (
        <Tooltip text="Error loading data" placement="bottom">
          <WarningYellowOutline
            size="sm"
            className="oui-ml-1 oui-mr-1"
            muted={false}
          />
        </Tooltip>
      )}
    </Tooltip>
  );
};

TableHeaderCell.propTypes = {
  className: PropTypes.string,
  column: PropTypes.object
};

export default TableHeaderCell;
